module.exports = __webpack_public_path__ + "img/iphone-12-shadow.64f4bff.png";